const { default: axiosInstance, endpoints } = require('src/utils/axios-visa');

/* eslint-disable class-methods-use-this */

class UserService {
  createUser = async (uid, displayName, phoneNumber, email, company, purpose) => {
    const payload = {
      displayName,
      email,
      phoneNumber,
      uid,
      purpose,
      ...(company && { company }),
    };

    const resp = await axiosInstance.post(endpoints.user.new, payload);
    return resp.data;
  };

  getUser = async (uid) => {
    const resp = await axiosInstance.get(endpoints.user.getUser(uid));
    return resp.data;
  };

  updateUser = async (uid, updateData) => {
    const updateObject = {};

    // Basic fields
    if (updateData.email) updateObject.email = updateData.email;
    if (updateData.phoneNumber) updateObject.phoneNumber = updateData.phoneNumber;
    if (updateData.displayName) updateObject.displayName = updateData.displayName;
    if (updateData.profileImage) updateObject.profileImage = updateData.profileImage;
    if (updateData.purpose) updateObject.purpose = updateData.purpose;

    // Get current user data for merging nested objects
    const visaUser = await this.getUser(uid);

    // Address object
    if (updateData.address) {
      updateObject.address = {
        ...(visaUser.address || {}),
        ...updateData.address,
      };
    }

    // Company object with nested fields
    if (updateData.company) {
      updateObject.company = {
        ...(visaUser.company || {}),
        ...updateData.company,
      };

      // Handle nested company address
      if (updateData.company.companyAddress) {
        updateObject.company.companyAddress = {
          ...(visaUser.company?.companyAddress || {}),
          ...updateData.company.companyAddress,
        };
      }

      // Handle nested social links
      if (updateData.company.socialLinks) {
        updateObject.company.socialLinks = {
          ...(visaUser.company?.socialLinks || {}),
          ...updateData.company.socialLinks,
        };
      }

      // Handle nested brand colors
      if (updateData.company.brandColors) {
        updateObject.company.brandColors = {
          ...(visaUser.company?.brandColors || {}),
          ...updateData.company.brandColors,
        };
      }
    }

    const resp = await axiosInstance.patch(endpoints.user.updateUser(uid), updateObject);
    return resp.data;
  };
}

const userService = new UserService();
export default userService;
